const prefix = "LEVY_COLLECTION_PROVIDER_";

export const DISMISS_SAP_RECONCILIATION_WARNING_FAILED = prefix + "DISMISS_SAP_RECONCILIATION_WARNING_FAILED";
export const DISMISS_SAP_RECONCILIATION_WARNING_STARTED = prefix + "DISMISS_SAP_RECONCILIATION_WARNING_STARTED";
export const DISMISS_SAP_RECONCILIATION_WARNING_SUCCEEDED = prefix + "DISMISS_SAP_RECONCILIATION_WARNING_SUCCEEDED";
export const EXISTS_FAILED = prefix + "EXISTS_FAILED";
export const EXISTS_STARTED = prefix + "EXISTS_STARTED";
export const EXISTS_SUCCEEDED = prefix + "EXISTS_SUCCEEDED";
export const EXPORT_FAILED = prefix + "EXPORT_FAILED";
export const EXPORT_STARTED = prefix + "EXPORT_STARTED";
export const EXPORT_SUCCEEDED = prefix + "EXPORT_SUCCEEDED";
export const FAVOURITE_QUIETLY_FAILED = prefix + "FAVOURITE_QUIETLY_FAILED";
export const FAVOURITE_QUIETLY_STARTED = prefix + "FAVOURITE_QUIETLY_STARTED";
export const FAVOURITE_QUIETLY_SUCCEEDED = prefix + "FAVOURITE_QUIETLY_SUCCEEDED";
export const FINALISE_GET_FAILED = prefix + "FINALISE_GET_FAILED";
export const FINALISE_GET_STARTED = prefix + "FINALISE_GET_STARTED";
export const FINALISE_GET_SUCCEEDED = prefix + "FINALISE_GET_SUCCEEDED";
export const FINALISE_SAVE_FAILED = prefix + "FINALISE_SAVE_FAILED";
export const FINALISE_SAVE_STARTED = prefix + "FINALISE_SAVE_STARTED";
export const FINALISE_SAVE_SUCCEEDED = prefix + "FINALISE_SAVE_SUCCEEDED";
export const FINALISE_UPDATE = prefix + "FINALISE_UPDATE";
export const GET_STATUS_HISTORY_FAILED = prefix + "GET_STATUS_HISTORY_FAILED";
export const GET_STATUS_HISTORY_STARTED = prefix + "GET_STATUS_HISTORY_STARTED";
export const GET_STATUS_HISTORY_SUCCEEDED = prefix + "GET_STATUS_HISTORY_SUCCEEDED";
export const GET_TIMELINE_FAILED = prefix + "GET_TIMELINE_FAILED";
export const GET_TIMELINE_STARTED = prefix + "GET_TIMELINE_STARTED";
export const GET_TIMELINE_SUCCEEDED = prefix + "GET_TIMELINE_SUCCEEDED";
export const IN_SCOPE_PREVIEW_GET_FAILED = prefix + "IN_SCOPE_PREVIEW_GET_FAILED";
export const IN_SCOPE_PREVIEW_GET_STARTED = prefix + "IN_SCOPE_PREVIEW_GET_STARTED";
export const IN_SCOPE_PREVIEW_GET_SUCCEEDED = prefix + "IN_SCOPE_PREVIEW_GET_SUCCEEDED";
export const ASSIGNED_PAYMENT_STATUS_INITIALISE = prefix + "ASSIGNED_PAYMENT_STATUS_INITIALISE";
export const ASSIGNED_PAYMENT_STATUS_SAVE_FAILED = prefix + "ASSIGNED_PAYMENT_STATUS_SAVE_FAILED";
export const ASSIGNED_PAYMENT_STATUS_SAVE_STARTED = prefix + "ASSIGNED_PAYMENT_STATUS_SAVE_STARTED";
export const ASSIGNED_PAYMENT_STATUS_SAVE_SUCCEEDED = prefix + "ASSIGNED_PAYMENT_STATUS_SAVE_SUCCEEDED";
export const ASSIGNED_PAYMENT_STATUS_UPDATE = prefix + "ASSIGNED_PAYMENT_STATUS_UPDATE";
export const LIST_CLEAR_CRITERIA = prefix + "LIST_CLEAR_CRITERIA";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_FOR_PROVIDER_FAILED = prefix + "LIST_FOR_PROVIDER_FAILED";
export const LIST_FOR_PROVIDER_STARTED = prefix + "LIST_FOR_PROVIDER_STARTED";
export const LIST_FOR_PROVIDER_SUCCEEDED = prefix + "LIST_FOR_PROVIDER_SUCCEEDED";
export const LIST_SET_CRITERIA = prefix + "LIST_SET_CRITERIA";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_FILTERS = prefix + "LIST_SET_FILTERS";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const STATE_UNLOAD_LISTING = prefix + "STATE_UNLOAD_LISTING";
export const TASK_GET_PROVIDERS_FAILED = prefix + "TASK_GET_PROVIDERS_FAILED";
export const TASK_GET_PROVIDERS_STARTED = prefix + "TASK_GET_PROVIDERS_STARTED";
export const TASK_GET_PROVIDERS_SUCCEEDED = prefix + "TASK_GET_PROVIDERS_SUCCEEDED";
export const TASK_RUN_FAILED = prefix + "TASK_RUN_FAILED";
export const TASK_RUN_QUIETLY_FAILED = prefix + "TASK_RUN_QUIETLY_FAILED";
export const TASK_RUN_QUIETLY_STARTED = prefix + "TASK_RUN_QUIETLY_STARTED";
export const TASK_RUN_QUIETLY_SUCCEEDED = prefix + "TASK_RUN_QUIETLY_SUCCEEDED";
export const TASK_RUN_STARTED = prefix + "TASK_RUN_STARTED";
export const TASK_RUN_SUCCEEDED = prefix + "TASK_RUN_SUCCEEDED";
export const TASKS_GET_FAILED = prefix + "TASKS_GET_FAILED";
export const TASKS_GET_STARTED = prefix + "TASKS_GET_STARTED";
export const TASKS_GET_SUCCEEDED = prefix + "TASKS_GET_SUCCEEDED";
export const UPLOAD_GET_TEMPLATE_FAILED = prefix + "UPLOAD_GET_TEMPLATE_FAILED";
export const UPLOAD_GET_TEMPLATE_STARTED = prefix + "UPLOAD_GET_TEMPLATE_STARTED";
export const UPLOAD_GET_TEMPLATE_SUCCEEDED = prefix + "UPLOAD_GET_TEMPLATE_SUCCEEDED";
export const UPLOAD_SPREADSHEET_FAILED = prefix + "UPLOAD_SPREADSHEET_FAILED";
export const UPLOAD_SPREADSHEET_RESET = prefix + "UPLOAD_SPREADSHEET_RESET";
export const UPLOAD_SPREADSHEET_SET_DRY_RUN = prefix + "UPLOAD_SPREADSHEET_SET_DRY_RUN";
export const UPLOAD_SPREADSHEET_STARTED = prefix + "UPLOAD_SPREADSHEET_STARTED";
export const UPLOAD_SPREADSHEET_SUCCEEDED = prefix + "UPLOAD_SPREADSHEET_SUCCEEDED";
export const VIEW_CLEAR = prefix + "VIEW_CLEAR";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_NEXT = prefix + "VIEW_NEXT";
export const VIEW_PREVIOUS = prefix + "VIEW_PREVIOUS";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
export const WARNINGS_GET_FAILED = prefix + "WARNINGS_GET_FAILED";
export const WARNINGS_GET_STARTED = prefix + "WARNINGS_GET_STARTED";
export const WARNINGS_GET_SUCCEEDED = prefix + "WARNINGS_GET_SUCCEEDED";
export const WARNINGS_SET_EXPANDED = prefix + "WARNINGS_SET_EXPANDED";
export const WARNINGS_SET_UNEXPANDED = prefix + "WARNINGS_SET_UNEXPANDED";
